import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import LoadingButton from '@mui/lab/LoadingButton';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { GridRowModes } from '@mui/x-data-grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import { BaseCheckbox } from '@mgm/common/components/base';
import { TBulkTableHeader } from '../../../../../components/bulk';
import { INITIAL_SCHEDULE_SHIFT } from '../../../../../data';
import { useAppDispatch } from '../../../../../hooks/useAppStore';
import { BulkConfirmDialog } from './BulkConfirmDialog';
import { schedulesActions } from '../../../../../store/schedules/slice';
import { ReactComponent as HelpIcon } from '../../../../../static/icons/ic_help.svg';

const BulkShiftsTableHeader: FC<TBulkTableHeader & {
  isInformEmployees: boolean
  setIsInformEmployees: (val: boolean) => void
}> = (props) => {
  const { t } = useTranslation(['timesheets', 'schedule', 'common']);
  const dispatch = useAppDispatch();

  const {
    setRows,
    setRowModesModel,
    rows,
    isInformEmployees,
    setIsInformEmployees,
  } = props;

  const handleClick = () => {
    const id = rows.length + 1;
    setRows((oldRows) => [...oldRows, { ...INITIAL_SCHEDULE_SHIFT, id }]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: 'employee' },
    }));
  };

  const handleCheckboxClick = () => {
    setIsInformEmployees(!isInformEmployees);
  };

  const onPublish = () => {
    setTimeout(() => {
      dispatch(schedulesActions.setIsOpenBulkDialog(true));
    }, 500);
  };

  return (
    <>
      <Grid paddingY={2} paddingX={2} container justifyContent="space-between">
        <Grid>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
              {t('addRecord', { ns: 'common' })}
            </Button>
            <Box display="flex" alignItems="center">
              <SvgIcon
                sx={{
                  fill: 'none',
                  mr: 0.5,
                  fontSize: 15,
                }}
                component={HelpIcon}
                inheritViewBox
              />
              <Typography variant="overline">{t('doubleClickOnARowToEdit', { ns: 'schedule' })}</Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid>
          <FormControlLabel
            sx={{
              pr: 2,
            }}
            control={(
              <BaseCheckbox
                handleClick={handleCheckboxClick}
                value={isInformEmployees}
                checked={isInformEmployees}
              />
            )}
            label={t('informEmployeeByEmail', { ns: 'schedule' })}
          />
          <LoadingButton
            onClick={onPublish}
            variant="contained"
          >
            {t('publish', { ns: 'schedule' })}
          </LoadingButton>
        </Grid>
      </Grid>
      <BulkConfirmDialog
        setRows={setRows}
        isInformEmployees={isInformEmployees}
        rows={rows}
      />
      <Divider sx={{ borderStyle: 'dashed' }} />
    </>
  );
};

export {
  BulkShiftsTableHeader,
};
